import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';

import { DATE_FORMAT_DISPLAY, DATE_FORMAT_VALUE } from '@constants';

// Port từ ra-log-monitor-cms/source/src/utils/datetimeHelper.js.
// moment -> dayjs (thư viện tương đương): antd 5 DatePicker chỉ nhận dayjs nên đây là bắt buộc.
// dayjs phân tích chuỗi CHẶT hơn moment -> phải nạp customParseFormat + utc (bẫy H1).
// Ánh xạ API: moment .hours()/.minutes() -> dayjs .hour()/.minute().
dayjs.extend(utc);
dayjs.extend(customParseFormat);

// Giữ nguyên tên viết sai của nguồn (DEFAUL_FORMAT) để dễ đối chiếu.
const DEFAUL_FORMAT = 'DD/MM/YYYY HH:mm:ss';

// ⚠️ KHÁC license (đọc settings.timezone, mặc định 7): nguồn ra-log-monitor lấy chênh lệch
// múi giờ CỦA TRÌNH DUYỆT.
const getUtcOffset = () => -new Date().getTimezoneOffset() / 60;

export const convertUtcToLocalTime = (utcTime, format = DATE_FORMAT_DISPLAY) => {
    try {
        if (utcTime) return dayjs(dayjs.utc(utcTime, DEFAUL_FORMAT).toDate()).format(format);
        return '';
    } catch (err) {
        return '';
    }
};

export const convertLocalTimeToUtc = (localTime, format) => {
    try {
        if (localTime) return dayjs(localTime, DEFAUL_FORMAT).utc().format(format);
        return '';
    } catch (err) {
        return '';
    }
};

export const convertStringToDateTime = (
    strFormDateTime,
    fromFormat = DATE_FORMAT_VALUE,
    toFormat = DATE_FORMAT_DISPLAY,
) => {
    try {
        if (strFormDateTime) {
            const datetime = dayjs(strFormDateTime, fromFormat);
            return dayjs(datetime.format(toFormat), toFormat);
        }
        return null;
    } catch (err) {
        return null;
    }
};

export const convertStringToDateTimeString = (
    strFormDateTime,
    fromFormat = DATE_FORMAT_VALUE,
    toFormat = DATE_FORMAT_DISPLAY,
) => {
    try {
        if (strFormDateTime) {
            const datetime = dayjs(strFormDateTime, fromFormat);
            return dayjs(datetime.format(toFormat), toFormat).format(toFormat);
        }
        return null;
    } catch (err) {
        return null;
    }
};

export const convertDateTimeToString = (datetime, stringFormat = DATE_FORMAT_VALUE) => {
    try {
        if (datetime) {
            return datetime.format(stringFormat);
        }
        return null;
    } catch (err) {
        return null;
    }
};

export const getDisabledHours = (minValue) => {
    const hours = [];
    for (let i = 0; i < 24; i++) {
        if (minValue && i < minValue.hour()) {
            hours.push(i);
        }
    }
    return hours;
};

export const getDisabledMinutes = (selectedHour, minValue) => {
    const minutes = [];
    for (let i = 0; i < 60; i++) {
        if (minValue && minValue.hour() === selectedHour && i < minValue.minute()) {
            minutes.push(i);
        }
    }
    return minutes;
};

// ⚠️ nguồn có THÊM tham số thứ ba `fromFormat` (license không có)
export const convertUtcToTimezone = (utcTime, format = DATE_FORMAT_DISPLAY, fromFormat = 'DD/MM/YYYY HH:mm:ss') => {
    const utcOffset = getUtcOffset();
    try {
        if (utcTime && format) return dayjs.utc(utcTime, fromFormat).utcOffset(utcOffset).format(format);
        return '';
    } catch (err) {
        return '';
    }
};

export const convertTimezoneToUtc = (localTime, format) => {
    const utcOffset = getUtcOffset();
    try {
        // ⚠️ KHÁC license (dùng offset ÂM): nguồn ra-log-monitor dùng offset DƯƠNG ở đây.
        if (localTime && format) return dayjs.utc(localTime, DEFAUL_FORMAT).utcOffset(utcOffset).format(format);
        return '';
    } catch (err) {
        return '';
    }
};
